import React from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { getClaimDetails, getCurrentUser } from "../../services/MainPage.Service";
import { getContractDetails, getDocuments } from "../../services/ClaimDetailsPage.Service";
import ClaimDetailsPage from "../claim-details-page/ClaimDetailsPage";
import Loader from "../loader/Loader";

const ClaimPage = () => {
    const [, setHeaderLogo] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(true);
    const [claimDetails, setClaimDetails] = React.useState(null);
    const [claimSummary, setClaimSummary] = React.useState(null);
    const [claimDocuments, setClaimDocuments] = React.useState(null);
    const [currentUser, setCurrentUser] = React.useState(null);

    const getClaimsData = async () => {
        const header = await JSON.parse(localStorage.getItem("tpa_data"));
        setHeaderLogo(header?.logo_Url);
        // document.body.className = header?.theme_Name;
        document.documentElement.style.setProperty('--button-primary-color',header?.custom_theme?.primary_button_color && header?.custom_theme?.primary_button_color);
        document.documentElement.style.setProperty('--already-claim-link',header?.custom_theme?.existing_claim_link_color && header?.custom_theme?.existing_claim_link_color);
        document.documentElement.style.setProperty('--header-background-color',header?.custom_theme?.header_background_color && header?.custom_theme?.header_background_color);
        document.documentElement.style.setProperty('--footer-background-color',header?.custom_theme?.footer_background_color && header?.custom_theme?.footer_background_color);
        document.documentElement.style.setProperty('--leinholder-menu-color',header?.custom_theme?.lienholder_menu_color && header?.custom_theme?.lienholder_menu_color);
        document.documentElement.style.setProperty('--button-disable-color',header?.custom_theme?.disabled_button_color && header?.custom_theme?.disabled_button_color);
        document.documentElement.style.setProperty('--warning-color',header?.custom_theme?.warning_color && header?.custom_theme?.warning_color);
        document.documentElement.style.setProperty('--footer-color',header?.custom_theme?.footer_color && header?.custom_theme?.footer_color);
        const claimData = await JSON.parse(localStorage.getItem("claim_number"));
        if (claimData) {
            const contractObj = {
                "contract_number": claimData?.contract?.number,
                "vin_number": claimData?.contract?.vin,
                "last_name": header.admin_Type === 'SEA' ? claimData?.contract?.customer?.name : claimData?.contract?.customer?.lastName
            };
            const claimObj = {
                "claim_number": header.admin_Type === 'SEA' ? claimData?.claimId : claimData?.claimNumber
            };                 
            const claimDocObj = {
                "claim_number": claimData?.claimNumber,
                "claim_id": claimData?.claimId
            };
            const res = await Promise.all([getClaimDetails(claimObj?.claim_number), getContractDetails(contractObj), getDocuments(claimDocObj)]);
            if (res) {
                setClaimSummary(res[0]?.data);
                setClaimDetails(res[1]?.data[0]);
                var attachmentsData = [];
                const tpaData = JSON.parse(localStorage.getItem('tpa_data'));
                if (tpaData?.admin_Type.toLowerCase() === 'sea') {
                    header?.required_docs?.forEach((item,i) => {
                        const selectedData = res[2]?.data?.find(x => x.description === item.documentName);
                        if (selectedData) {
                            const selectedAttachment = { ...item, attachmentData: selectedData };
                            attachmentsData.push(selectedAttachment);
                        } else {
                            const selectedAttachment = { ...item, attachmentData: { 'identifier': `sea-${i}`} }
                            attachmentsData.push(selectedAttachment);
                        }
                    });
                } else {
                    header?.required_docs?.forEach((item) => {
                        const selectedData = res[2]?.data?.find(x => x.description === item.documentName);
                        if (selectedData) {
                            const selectedAttachment = { ...item, attachmentData: selectedData };
                            attachmentsData.push(selectedAttachment);
                        }
                    });
                }
                setClaimDocuments(attachmentsData);
                setIsLoading(false);
                return;
            }
            setIsLoading(false);
        }
    }
    React.useEffect(() => {
        setIsLoading(true);
        getClaimsData();
    }, [])
    React.useEffect(() => {
        let cancelled = false;
        getCurrentUser().then((me) => {
            if (!cancelled) {
                setCurrentUser(me);
            }
        });
        return () => { cancelled = true; };
    }, [])
    React.useEffect(() => {
        setClaimDetails(claimDetails);
    }, [claimDetails])
    React.useEffect(() => {
        setClaimSummary(claimSummary);
    }, [claimSummary])
    return (
        <React.Fragment>
            {isLoading ? <Loader /> :
                <React.Fragment>
                    <Header isContractLookup={false} currentUser={currentUser} />
                    <ClaimDetailsPage claimData={claimDetails && claimDetails} claimSummaryData={claimSummary && claimSummary} claimDocuments={claimDocuments && claimDocuments} />
                    <Footer />
                </React.Fragment>
            }
        </React.Fragment>
    )
};

export default ClaimPage;